/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import IconBack from '../../../assets/Images/icons/icon-back';
import RiskRegisterFormEdit from './RiskRegisterFormEdit';
import RiskRegisterFormView from './RiskRegisterFormView';
import RiskRegisterService from '../../../services/RiskRegister.service';

export default function RiskRegisterForm() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [detail, setDetail] = useState();
    const location = useLocation();
    const { mode, options, subOption, activityId } = location?.state;

    useEffect(() => {
        const getRiskRegisterDetail = async (id) => {
            const { data } = await RiskRegisterService.getRiskRegisterDetail(
                id
            );
            if (data?.resultData) {
                setDetail(data?.resultData);
            }
        };
        if (subOption?.id || options?.id) {
            let id = subOption?.id
                ? subOption?.id
                : subOption?.id !== null
                ? options?.id
                : null;
            getRiskRegisterDetail(id);
        }
    }, []);

    return (
        <div>
            <div className="title flex">
                <button
                    className="cursor-pointer mr-3"
                    onClick={() => {
                        navigate(-1, { state: { mode, activityId } });
                    }}
                >
                    <IconBack />
                </button>
                {t('RR.IdentifyRiskFactors')}
            </div>
            <div className="sub-title">
                <span className="text-sm text-gray-400">
                    {t('Risk Register')} /
                </span>
                <span className="text-sm text-gray-400">
                    {' '}
                    {t('Risk Register List')} /{' '}
                </span>
                <span>{t('RR.IdentifyRiskFactors')}</span>
            </div>

            {(mode === 'view' || mode === 'clone' || mode === 'connect') && (
                <RiskRegisterFormView detail={detail} />
            )}
            {(mode === 'create' || mode === 'edit') && (
                <RiskRegisterFormEdit detail={detail} setDetail={setDetail} />
            )}
        </div>
    );
}
